// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { deleteApiCommentsByIdUnlikeResponseTransformer, deleteApiPositionedBannersByIdResponseTransformer, deleteApiPostsByIdUnlikeResponseTransformer, getApiClubsByIdFeedResponseTransformer, getApiClubsByIdResponseTransformer, getApiDrawsByIdResponseTransformer, getApiPositionedBannersByIdByIdResponseTransformer, getApiPositionedBannersResponseTransformer, getApiUsersByIdPostsResponseTransformer, getApiUsersByIdPreviewResponseTransformer, getApiUsersFeedMatchesResponseTransformer, getApiUsersFeedNewsResponseTransformer, getApiUsersFeedOffersResponseTransformer, getApiUsersFeedPostsResponseTransformer, getApiUsersFeedResponseTransformer, getApiUsersFollowersListByIdResponseTransformer, getApiUsersUserMatchesResponseTransformer, postApiCommentsByIdLikeResponseTransformer, postApiPositionedBannersResponseTransformer, postApiPostsByIdLikeResponseTransformer, postApiPostsResponseTransformer, postApiSessionsBackofficeResponseTransformer, postApiSessionsFacebookResponseTransformer, postApiSessionsResponseTransformer, postApiUsersMarketResponseTransformer, postApiUsersSignUpAdditionalInfoResponseTransformer, postApiUsersSignUpResponseTransformer, putApiDrawsByIdChangeBestLoserRankingResponseTransformer, putApiDrawsByIdChangeWinnerResponseTransformer, putApiDrawsByIdDeleteMatchesResponseTransformer, putApiEditProfileGeneralInfoResponseTransformer, putApiPositionedBannersByIdResponseTransformer } from './transformers.gen';
import type { DeleteApiBonusesByIdData, DeleteApiBonusesByIdErrors, DeleteApiBonusesByIdResponses, DeleteApiCommentsByIdUnlikeData, DeleteApiCommentsByIdUnlikeErrors, DeleteApiCommentsByIdUnlikeResponses, DeleteApiCustomBannersByIdData, DeleteApiCustomBannersByIdErrors, DeleteApiCustomBannersByIdResponses, DeleteApiDrawsByIdData, DeleteApiDrawsByIdErrors, DeleteApiDrawsByIdResponses, DeleteApiEndorsementsByIdData, DeleteApiEndorsementsByIdErrors, DeleteApiEndorsementsByIdResponses, DeleteApiMatchesByIdData, DeleteApiMatchesByIdErrors, DeleteApiMatchesByIdResponses, DeleteApiOffersByIdData, DeleteApiOffersByIdErrors, DeleteApiOffersByIdResponses, DeleteApiPositionedBannersByIdData, DeleteApiPositionedBannersByIdResponses, DeleteApiPostsByIdUnlikeData, DeleteApiPostsByIdUnlikeErrors, DeleteApiPostsByIdUnlikeResponses, DeleteApiPostsByPostIdCommentsByIdData, DeleteApiPostsByPostIdCommentsByIdErrors, DeleteApiPostsByPostIdCommentsByIdResponses, DeleteApiPremiumTokensByIdData, DeleteApiPremiumTokensByIdErrors, DeleteApiPremiumTokensByIdResponses, DeleteApiSavedCompetitionSearchData, DeleteApiSavedCompetitionSearchErrors, DeleteApiSavedCompetitionSearchResponses, DeleteApiSessionsByIdData, DeleteApiSessionsByIdResponses, DeleteApiUserMatchesByIdData, DeleteApiUserMatchesByIdErrors, DeleteApiUserMatchesByIdResponses, GetApiBonusesData, GetApiBonusesErrors, GetApiBonusesResponses, GetApiCardinalityData, GetApiCardinalityResponses, GetApiClubsByIdData, GetApiClubsByIdErrors, GetApiClubsByIdFeedData, GetApiClubsByIdFeedErrors, GetApiClubsByIdFeedResponses, GetApiClubsByIdResponses, GetApiClubsIdByFitClubIdByFitClubIdData, GetApiClubsIdByFitClubIdByFitClubIdErrors, GetApiClubsIdByFitClubIdByFitClubIdResponses, GetApiCompetitionsByIdData, GetApiCompetitionsByIdErrors, GetApiCompetitionsByIdResponses, GetApiCompetitionsSearchData, GetApiCompetitionsSearchResponses, GetApiCustomBannersAllData, GetApiCustomBannersAllResponses, GetApiCustomBannersByIdData, GetApiCustomBannersByIdErrors, GetApiCustomBannersByIdResponses, GetApiCustomBannersData, GetApiCustomBannersResponses, GetApiDrawsByIdData, GetApiDrawsByIdErrors, GetApiDrawsByIdResponses, GetApiEditProfileProfilesData, GetApiEditProfileProfilesErrors, GetApiEditProfileProfilesResponses, GetApiFakeRouteToTestLoginCheckData, GetApiFakeRouteToTestLoginCheckErrors, GetApiFakeRouteToTestLoginCheckResponses, GetApiFeedNewsData, GetApiFeedNewsResponses, GetApiFitPlayerProfileRequestsData, GetApiFitPlayerProfileRequestsResponses, GetApiFitPlayerProfilesAdvancedSearchFiltersData, GetApiFitPlayerProfilesAdvancedSearchFiltersResponses, GetApiFitPlayerProfilesByIdData, GetApiFitPlayerProfilesByIdEndorsementsData, GetApiFitPlayerProfilesByIdEndorsementsResponses, GetApiFitPlayerProfilesByIdErrors, GetApiFitPlayerProfilesByIdFeedData, GetApiFitPlayerProfilesByIdFeedResponses, GetApiFitPlayerProfilesByIdHarmonizationData, GetApiFitPlayerProfilesByIdHarmonizationErrors, GetApiFitPlayerProfilesByIdHarmonizationResponses, GetApiFitPlayerProfilesByIdRankData, GetApiFitPlayerProfilesByIdRankResponses, GetApiFitPlayerProfilesByIdReducedData, GetApiFitPlayerProfilesByIdReducedResponses, GetApiFitPlayerProfilesByIdResponses, GetApiFitPlayerProfilesByIdSimulatorData, GetApiFitPlayerProfilesByIdSimulatorErrors, GetApiFitPlayerProfilesByIdSimulatorResponses, GetApiFitPlayerProfilesByIdStatsData, GetApiFitPlayerProfilesByIdStatsResponses, GetApiFitPlayerProfilesByIdUserInfoData, GetApiFitPlayerProfilesByIdUserInfoResponses, GetApiFitPlayerProfilesByIdVisitorsData, GetApiFitPlayerProfilesByIdVisitorsResponses, GetApiFitPlayerProfilesByIdVisitsData, GetApiFitPlayerProfilesByIdVisitsResponses, GetApiFitPlayerProfilesCardToIdByCardNumberData, GetApiFitPlayerProfilesCardToIdByCardNumberErrors, GetApiFitPlayerProfilesCardToIdByCardNumberResponses, GetApiFitPlayerProfilesFollowersListByIdData, GetApiFitPlayerProfilesFollowersListByIdResponses, GetApiFitPlayerProfilesMostVisitedData, GetApiFitPlayerProfilesMostVisitedResponses, GetApiFitPlayerProfilesSearchData, GetApiFitPlayerProfilesSearchForMergeByQData, GetApiFitPlayerProfilesSearchForMergeByQResponses, GetApiFitPlayerProfilesSearchForMergeData, GetApiFitPlayerProfilesSearchForMergeResponses, GetApiFitPlayerProfilesSearchResponses, GetApiHomeBackofficeNumbersData, GetApiHomeBackofficeNumbersResponses, GetApiHomeData, GetApiHomeNotificationsData, GetApiHomeNotificationsResponses, GetApiHomeNumbersData, GetApiHomeNumbersResponses, GetApiHomeRateData, GetApiHomeRateResponses, GetApiHomeResponses, GetApiMatchesByIdData, GetApiMatchesByIdErrors, GetApiMatchesByIdResponses, GetApiMatchesData, GetApiMatchesResponses, GetApiMessagesConversationData, GetApiMessagesConversationResponses, GetApiOffersByIdData, GetApiOffersByIdErrors, GetApiOffersByIdResponses, GetApiOffersPrivatesData, GetApiOffersPrivatesErrors, GetApiOffersPrivatesResponses, GetApiOffersShopsData, GetApiOffersShopsResponses, GetApiPositionedBannersByIdByIdData, GetApiPositionedBannersByIdByIdErrors, GetApiPositionedBannersByIdByIdResponses, GetApiPositionedBannersBySlotData, GetApiPositionedBannersBySlotErrors, GetApiPositionedBannersBySlotResponses, GetApiPositionedBannersData, GetApiPositionedBannersResponses, GetApiPremiumTokensByIdData, GetApiPremiumTokensByIdErrors, GetApiPremiumTokensByIdResponses, GetApiPremiumTokensData, GetApiPremiumTokensResponses, GetApiSavedCompetitionSearchData, GetApiSavedCompetitionSearchErrors, GetApiSavedCompetitionSearchResponses, GetApiTournamentsByIdData, GetApiTournamentsByIdErrors, GetApiTournamentsByIdResponses, GetApiUpdateTasksData, GetApiUpdateTasksResponses, GetApiUserMatchesByIdData, GetApiUserMatchesByIdErrors, GetApiUserMatchesByIdResponses, GetApiUserMatchesData, GetApiUserMatchesResponses, GetApiUsersByIdData, GetApiUsersByIdPostsData, GetApiUsersByIdPostsResponses, GetApiUsersByIdPreviewData, GetApiUsersByIdPreviewResponses, GetApiUsersByIdResponses, GetApiUsersByTokenFitPlayerIdData, GetApiUsersByTokenFitPlayerIdResponses, GetApiUsersConfirmAccountByTokenData, GetApiUsersConfirmAccountByTokenResponses, GetApiUsersFacebookInfoByTokenData, GetApiUsersFacebookInfoByTokenResponses, GetApiUsersFeedData, GetApiUsersFeedMatchesData, GetApiUsersFeedMatchesResponses, GetApiUsersFeedNewsData, GetApiUsersFeedNewsResponses, GetApiUsersFeedOffersData, GetApiUsersFeedOffersResponses, GetApiUsersFeedPostsData, GetApiUsersFeedPostsResponses, GetApiUsersFeedResponses, GetApiUsersFollowersListByIdData, GetApiUsersFollowersListByIdResponses, GetApiUsersMessagesCounterpartsData, GetApiUsersMessagesCounterpartsResponses, GetApiUsersNotificationsData, GetApiUsersNotificationsDropdownData, GetApiUsersNotificationsDropdownResponses, GetApiUsersNotificationsResponses, GetApiUsersPreferredSurfacesData, GetApiUsersPreferredSurfacesResponses, GetApiUsersTeacherQualificationsData, GetApiUsersTeacherQualificationsResponses, GetApiUsersTrainerQualificationsData, GetApiUsersTrainerQualificationsResponses, GetApiUsersUserMatchesData, GetApiUsersUserMatchesResponses, PatchApiCustomBannersByIdData, PatchApiCustomBannersByIdErrors, PatchApiCustomBannersByIdResponses, PatchApiMatchesByIdData, PatchApiMatchesByIdErrors, PatchApiMatchesByIdResponses, PatchApiOffersByIdData, PatchApiOffersByIdErrors, PatchApiOffersByIdResponses, PatchApiPostsByPostIdCommentsByIdData, PatchApiPostsByPostIdCommentsByIdResponses, PostApiBonusesData, PostApiBonusesErrors, PostApiBonusesResponses, PostApiCardinalitySaveData, PostApiCardinalitySaveResponses, PostApiCommentsByIdLikeData, PostApiCommentsByIdLikeErrors, PostApiCommentsByIdLikeResponses, PostApiCompetitionsAdvancedSearchData, PostApiCompetitionsAdvancedSearchResponses, PostApiContactsData, PostApiContactsResponses, PostApiCustomBannersData, PostApiCustomBannersResponses, PostApiEditProfileAppTokenInfoData, PostApiEditProfileAppTokenInfoErrors, PostApiEndorsementsData, PostApiEndorsementsResponses, PostApiFitPlayerProfilesAdvancedSearchData, PostApiFitPlayerProfilesAdvancedSearchErrors, PostApiFitPlayerProfilesAdvancedSearchResponses, PostApiFitPlayerProfilesCheckFitCardNumberData, PostApiFitPlayerProfilesCheckFitCardNumberResponses, PostApiFollowsData, PostApiFollowsResponses, PostApiHomeInlineSearchData, PostApiHomeInlineSearchPlayersData, PostApiHomeInlineSearchPlayersResponses, PostApiHomeInlineSearchResponses, PostApiHomeInvitationData, PostApiHomeInvitationResponses, PostApiHomeSendAllNotificationsData, PostApiHomeSendAllNotificationsResponses, PostApiMatchesData, PostApiMatchesResponses, PostApiMessagesData, PostApiMessagesResponses, PostApiOffersData, PostApiOffersErrors, PostApiOffersResponses, PostApiOffersSearchData, PostApiOffersSearchResponses, PostApiPositionedBannersData, PostApiPositionedBannersResponses, PostApiPostsByIdLikeData, PostApiPostsByIdLikeErrors, PostApiPostsByIdLikeResponses, PostApiPostsByPostIdCommentsData, PostApiPostsByPostIdCommentsResponses, PostApiPostsData, PostApiPostsErrors, PostApiPostsResponses, PostApiPremiumTokensData, PostApiPremiumTokensMembershipEmailData, PostApiPremiumTokensMembershipEmailResponses, PostApiPremiumTokensResponses, PostApiRemoveFollowData, PostApiRemoveFollowErrors, PostApiRemoveFollowResponses, PostApiSavedCompetitionSearchData, PostApiSavedCompetitionSearchErrors, PostApiSavedCompetitionSearchResponses, PostApiSearchClubsData, PostApiSearchClubsResponses, PostApiSearchCompetitionsData, PostApiSearchCompetitionsResponses, PostApiSearchOtherProfilesData, PostApiSearchOtherProfilesResponses, PostApiSearchPlayersData, PostApiSearchPlayersResponses, PostApiSessionsAppleWebAuthData, PostApiSessionsAppleWebAuthResponses, PostApiSessionsBackofficeData, PostApiSessionsBackofficeResponses, PostApiSessionsData, PostApiSessionsFacebookData, PostApiSessionsFacebookLimitedData, PostApiSessionsFacebookLimitedResponses, PostApiSessionsFacebookResponses, PostApiSessionsResponses, PostApiShopifyOrderData, PostApiShopifyOrderErrors, PostApiShopifyOrderResponses, PostApiUpdateTasksCacheRefreshData, PostApiUpdateTasksCacheRefreshResponses, PostApiUpdateTasksData, PostApiUpdateTasksResponses, PostApiUpdateTasksRestartServersData, PostApiUpdateTasksRestartServersResponses, PostApiUpdateTasksRunAsyncJobData, PostApiUpdateTasksRunAsyncJobErrors, PostApiUpdateTasksRunAsyncJobResponses, PostApiUpdateTasksRunRestoreDumpData, PostApiUpdateTasksRunRestoreDumpResponses, PostApiUserMatchesData, PostApiUserMatchesResponses, PostApiUsersAccountConfirmationEmailData, PostApiUsersAccountConfirmationEmailResponses, PostApiUsersCheckFitClubIdData, PostApiUsersCheckFitClubIdResponses, PostApiUsersCompleteProfileData, PostApiUsersCompleteProfileErrors, PostApiUsersCompleteProfileResponses, PostApiUsersMarketData, PostApiUsersMarketResponses, PostApiUsersSignUpAdditionalInfoData, PostApiUsersSignUpAdditionalInfoErrors, PostApiUsersSignUpAdditionalInfoResponses, PostApiUsersSignUpData, PostApiUsersSignUpResponses, PutApiCustomBannersByIdData, PutApiCustomBannersByIdErrors, PutApiCustomBannersByIdResponses, PutApiDrawsByIdChangeBestLoserRankingData, PutApiDrawsByIdChangeBestLoserRankingErrors, PutApiDrawsByIdChangeBestLoserRankingResponses, PutApiDrawsByIdChangeWinnerData, PutApiDrawsByIdChangeWinnerErrors, PutApiDrawsByIdChangeWinnerResponses, PutApiDrawsByIdDeleteMatchesData, PutApiDrawsByIdDeleteMatchesErrors, PutApiDrawsByIdDeleteMatchesResponses, PutApiEditProfileAccountInfoData, PutApiEditProfileAccountInfoErrors, PutApiEditProfileAccountInfoResponses, PutApiEditProfileAppTokenInfoData, PutApiEditProfileAppTokenInfoErrors, PutApiEditProfileAppTokenInfoResponses, PutApiEditProfileDeleteProfileData, PutApiEditProfileDeleteProfileErrors, PutApiEditProfileDeleteProfileResponses, PutApiEditProfileGeneralInfoData, PutApiEditProfileGeneralInfoErrors, PutApiEditProfileGeneralInfoResponses, PutApiEditProfileProfilesInfoData, PutApiEditProfileProfilesInfoErrors, PutApiEditProfileProfilesInfoResponses, PutApiEditProfileRemovePlayerProfileAssociationsData, PutApiEditProfileRemovePlayerProfileAssociationsErrors, PutApiEditProfileRemovePlayerProfileAssociationsResponses, PutApiEditProfileRemovePlayerProfileData, PutApiEditProfileRemovePlayerProfileErrors, PutApiEditProfileRemovePlayerProfileResponses, PutApiFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdData, PutApiFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdResponses, PutApiMatchesByIdData, PutApiMatchesByIdErrors, PutApiMatchesByIdResponses, PutApiMatchesByIdResultData, PutApiMatchesByIdResultErrors, PutApiMatchesByIdResultResponses, PutApiMessagesByIdBlockData, PutApiMessagesByIdBlockResponses, PutApiOffersByIdData, PutApiOffersByIdResponses, PutApiPositionedBannersByIdData, PutApiPositionedBannersByIdResponses, PutApiPremiumTokensByIdData, PutApiPremiumTokensByIdErrors, PutApiPremiumTokensByIdResponses, PutApiResetPasswordData, PutApiResetPasswordRequestData, PutApiResetPasswordRequestResponses, PutApiResetPasswordResponses, PutApiUpdateTasksByIdRunData, PutApiUpdateTasksByIdRunResponses, PutApiUpdateTasksByIdSetPendingData, PutApiUpdateTasksByIdSetPendingResponses, PutApiUserMatchesByIdConfirmData, PutApiUserMatchesByIdConfirmErrors, PutApiUserMatchesByIdConfirmResponses, PutApiUserMatchesByIdData, PutApiUserMatchesByIdErrors, PutApiUserMatchesByIdRejectData, PutApiUserMatchesByIdRejectErrors, PutApiUserMatchesByIdRejectResponses, PutApiUserMatchesByIdResponses, PutApiUserMatchesByIdResultData, PutApiUserMatchesByIdResultErrors, PutApiUserMatchesByIdResultResponses, PutApiUsersMarketConditionAcceptedData, PutApiUsersMarketConditionAcceptedResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Logs out a user
 */
export const deleteApiSessionsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiSessionsByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiSessionsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/sessions/{id}',
        ...options
    });
};

/**
 * Logs in a user with Facebook
 */
export const postApiSessionsFacebook = <ThrowOnError extends boolean = false>(options?: Options<PostApiSessionsFacebookData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSessionsFacebookResponses, unknown, ThrowOnError>({
        responseTransformer: postApiSessionsFacebookResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/sessions/facebook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Logs in a user with Facebook with JWT instead of old normal token
 */
export const postApiSessionsFacebookLimited = <ThrowOnError extends boolean = false>(options?: Options<PostApiSessionsFacebookLimitedData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSessionsFacebookLimitedResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/sessions/facebook_limited',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Logs in a user with Apple (web)
 */
export const postApiSessionsAppleWebAuth = <ThrowOnError extends boolean = false>(options?: Options<PostApiSessionsAppleWebAuthData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSessionsAppleWebAuthResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/sessions/apple-web-auth',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Logs in a backoffice user
 */
export const postApiSessionsBackoffice = <ThrowOnError extends boolean = false>(options?: Options<PostApiSessionsBackofficeData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSessionsBackofficeResponses, unknown, ThrowOnError>({
        responseTransformer: postApiSessionsBackofficeResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/sessions/backoffice',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Tests login check
 */
export const getApiFakeRouteToTestLoginCheck = <ThrowOnError extends boolean = false>(options?: Options<GetApiFakeRouteToTestLoginCheckData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiFakeRouteToTestLoginCheckResponses, GetApiFakeRouteToTestLoginCheckErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fake-route-to-test-login-check',
        ...options
    });
};

/**
 * Mostra i dettagli di un club
 */
export const getApiClubsById = <ThrowOnError extends boolean = false>(options: Options<GetApiClubsByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiClubsByIdResponses, GetApiClubsByIdErrors, ThrowOnError>({
        responseTransformer: getApiClubsByIdResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/clubs/{id}',
        ...options
    });
};

/**
 * Restituisce il feed di un club
 */
export const getApiClubsByIdFeed = <ThrowOnError extends boolean = false>(options: Options<GetApiClubsByIdFeedData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiClubsByIdFeedResponses, GetApiClubsByIdFeedErrors, ThrowOnError>({
        responseTransformer: getApiClubsByIdFeedResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/clubs/{id}/feed',
        ...options
    });
};

/**
 * Restituisce l'ID del club dato un fit_club_id
 */
export const getApiClubsIdByFitClubIdByFitClubId = <ThrowOnError extends boolean = false>(options: Options<GetApiClubsIdByFitClubIdByFitClubIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiClubsIdByFitClubIdByFitClubIdResponses, GetApiClubsIdByFitClubIdByFitClubIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/clubs/id-by-fit-club-id/{fit_club_id}',
        ...options
    });
};

/**
 * Mette like a un commento
 */
export const postApiCommentsByIdLike = <ThrowOnError extends boolean = false>(options: Options<PostApiCommentsByIdLikeData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiCommentsByIdLikeResponses, PostApiCommentsByIdLikeErrors, ThrowOnError>({
        responseTransformer: postApiCommentsByIdLikeResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/comments/{id}/like',
        ...options
    });
};

/**
 * Rimuove il like da un commento
 */
export const deleteApiCommentsByIdUnlike = <ThrowOnError extends boolean = false>(options: Options<DeleteApiCommentsByIdUnlikeData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiCommentsByIdUnlikeResponses, DeleteApiCommentsByIdUnlikeErrors, ThrowOnError>({
        responseTransformer: deleteApiCommentsByIdUnlikeResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/comments/{id}/unlike',
        ...options
    });
};

/**
 * Mostra i dettagli di una competizione
 */
export const getApiCompetitionsById = <ThrowOnError extends boolean = false>(options: Options<GetApiCompetitionsByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiCompetitionsByIdResponses, GetApiCompetitionsByIdErrors, ThrowOnError>({
        url: '/api/competitions/{id}',
        ...options
    });
};

/**
 * Ricerca competizioni per query
 */
export const getApiCompetitionsSearch = <ThrowOnError extends boolean = false>(options: Options<GetApiCompetitionsSearchData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiCompetitionsSearchResponses, unknown, ThrowOnError>({
        url: '/api/competitions/search',
        ...options
    });
};

/**
 * Ricerca avanzata competizioni
 */
export const postApiCompetitionsAdvancedSearch = <ThrowOnError extends boolean = false>(options?: Options<PostApiCompetitionsAdvancedSearchData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiCompetitionsAdvancedSearchResponses, unknown, ThrowOnError>({
        url: '/api/competitions/advanced-search',
        ...options
    });
};

/**
 * Elimina un tabellone (draw) e i suoi match
 */
export const deleteApiDrawsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiDrawsByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiDrawsByIdResponses, DeleteApiDrawsByIdErrors, ThrowOnError>({
        url: '/api/draws/{id}',
        ...options
    });
};

/**
 * Mostra un tabellone (draw)
 */
export const getApiDrawsById = <ThrowOnError extends boolean = false>(options: Options<GetApiDrawsByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiDrawsByIdResponses, GetApiDrawsByIdErrors, ThrowOnError>({
        responseTransformer: getApiDrawsByIdResponseTransformer,
        url: '/api/draws/{id}',
        ...options
    });
};

/**
 * Elimina tutti i match di un tabellone
 */
export const putApiDrawsByIdDeleteMatches = <ThrowOnError extends boolean = false>(options: Options<PutApiDrawsByIdDeleteMatchesData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiDrawsByIdDeleteMatchesResponses, PutApiDrawsByIdDeleteMatchesErrors, ThrowOnError>({
        responseTransformer: putApiDrawsByIdDeleteMatchesResponseTransformer,
        url: '/api/draws/{id}/delete-matches',
        ...options
    });
};

/**
 * Cambia il vincitore di un tabellone
 */
export const putApiDrawsByIdChangeWinner = <ThrowOnError extends boolean = false>(options: Options<PutApiDrawsByIdChangeWinnerData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiDrawsByIdChangeWinnerResponses, PutApiDrawsByIdChangeWinnerErrors, ThrowOnError>({
        responseTransformer: putApiDrawsByIdChangeWinnerResponseTransformer,
        url: '/api/draws/{id}/change-winner',
        ...options
    });
};

/**
 * Cambia il best loser ranking di un tabellone
 */
export const putApiDrawsByIdChangeBestLoserRanking = <ThrowOnError extends boolean = false>(options: Options<PutApiDrawsByIdChangeBestLoserRankingData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiDrawsByIdChangeBestLoserRankingResponses, PutApiDrawsByIdChangeBestLoserRankingErrors, ThrowOnError>({
        responseTransformer: putApiDrawsByIdChangeBestLoserRankingResponseTransformer,
        url: '/api/draws/{id}/change-best-loser-ranking',
        ...options
    });
};

/**
 * Restituisce i profili dell'utente
 */
export const getApiEditProfileProfiles = <ThrowOnError extends boolean = false>(options: Options<GetApiEditProfileProfilesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiEditProfileProfilesResponses, GetApiEditProfileProfilesErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/profiles',
        ...options
    });
};

/**
 * Aggiorna le informazioni generali dell'utente
 */
export const putApiEditProfileGeneralInfo = <ThrowOnError extends boolean = false>(options?: Options<PutApiEditProfileGeneralInfoData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutApiEditProfileGeneralInfoResponses, PutApiEditProfileGeneralInfoErrors, ThrowOnError>({
        responseTransformer: putApiEditProfileGeneralInfoResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/general-info',
        ...options
    });
};

/**
 * Aggiorna le informazioni account dell'utente
 */
export const putApiEditProfileAccountInfo = <ThrowOnError extends boolean = false>(options?: Options<PutApiEditProfileAccountInfoData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutApiEditProfileAccountInfoResponses, PutApiEditProfileAccountInfoErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/account-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Aggiorna le informazioni dei profili secondari
 */
export const putApiEditProfileProfilesInfo = <ThrowOnError extends boolean = false>(options?: Options<PutApiEditProfileProfilesInfoData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutApiEditProfileProfilesInfoResponses, PutApiEditProfileProfilesInfoErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/profiles-info',
        ...options
    });
};

/**
 * Gestisce il token dell'app
 */
export const postApiEditProfileAppTokenInfo = <ThrowOnError extends boolean = false>(options: Options<PostApiEditProfileAppTokenInfoData, ThrowOnError>) => {
    return (options.client ?? client).post<unknown, PostApiEditProfileAppTokenInfoErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/app-token-info',
        ...options
    });
};

/**
 * update app token info
 */
export const putApiEditProfileAppTokenInfo = <ThrowOnError extends boolean = false>(options: Options<PutApiEditProfileAppTokenInfoData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiEditProfileAppTokenInfoResponses, PutApiEditProfileAppTokenInfoErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/app-token-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Elimina un profilo secondario
 */
export const putApiEditProfileDeleteProfile = <ThrowOnError extends boolean = false>(options: Options<PutApiEditProfileDeleteProfileData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiEditProfileDeleteProfileResponses, PutApiEditProfileDeleteProfileErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/delete-profile',
        ...options
    });
};

/**
 * Rimuove il profilo giocatore dell'utente corrente
 */
export const putApiEditProfileRemovePlayerProfile = <ThrowOnError extends boolean = false>(options: Options<PutApiEditProfileRemovePlayerProfileData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiEditProfileRemovePlayerProfileResponses, PutApiEditProfileRemovePlayerProfileErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/remove-player-profile',
        ...options
    });
};

/**
 * Rimuove le associazioni del profilo giocatore
 */
export const putApiEditProfileRemovePlayerProfileAssociations = <ThrowOnError extends boolean = false>(options: Options<PutApiEditProfileRemovePlayerProfileAssociationsData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiEditProfileRemovePlayerProfileAssociationsResponses, PutApiEditProfileRemovePlayerProfileAssociationsErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/edit-profile/remove-player-profile-associations',
        ...options
    });
};

/**
 * Mostra il profilo FIT di un giocatore
 */
export const getApiFitPlayerProfilesById = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdResponses, GetApiFitPlayerProfilesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}',
        ...options
    });
};

/**
 * Ricerca profili FIT
 */
export const getApiFitPlayerProfilesSearch = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesSearchData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesSearchResponses, unknown, ThrowOnError>({
        url: '/api/fit-player-profiles/search',
        ...options
    });
};

/**
 * Ricerca avanzata profili FIT
 */
export const postApiFitPlayerProfilesAdvancedSearch = <ThrowOnError extends boolean = false>(options?: Options<PostApiFitPlayerProfilesAdvancedSearchData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiFitPlayerProfilesAdvancedSearchResponses, PostApiFitPlayerProfilesAdvancedSearchErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/advanced-search',
        ...options
    });
};

/**
 * Restituisce i filtri per la ricerca avanzata
 */
export const getApiFitPlayerProfilesAdvancedSearchFilters = <ThrowOnError extends boolean = false>(options?: Options<GetApiFitPlayerProfilesAdvancedSearchFiltersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiFitPlayerProfilesAdvancedSearchFiltersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/advanced-search/filters',
        ...options
    });
};

/**
 * Restituisce il rank attuale del profilo FIT
 */
export const getApiFitPlayerProfilesByIdRank = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdRankData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdRankResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/rank',
        ...options
    });
};

/**
 * Restituisce le statistiche del profilo FIT
 */
export const getApiFitPlayerProfilesByIdStats = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdStatsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdStatsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/stats',
        ...options
    });
};

/**
 * Simulatore ranking per il profilo FIT
 */
export const getApiFitPlayerProfilesByIdSimulator = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdSimulatorData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdSimulatorResponses, GetApiFitPlayerProfilesByIdSimulatorErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/simulator',
        ...options
    });
};

/**
 * Restituisce la harmonization del profilo FIT
 */
export const getApiFitPlayerProfilesByIdHarmonization = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdHarmonizationData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdHarmonizationResponses, GetApiFitPlayerProfilesByIdHarmonizationErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/harmonization',
        ...options
    });
};

/**
 * Restituisce gli endorsement del profilo FIT
 */
export const getApiFitPlayerProfilesByIdEndorsements = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdEndorsementsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdEndorsementsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/endorsements',
        ...options
    });
};

/**
 * Restituisce il numero di visite del profilo FIT
 */
export const getApiFitPlayerProfilesByIdVisits = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdVisitsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdVisitsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/visits',
        ...options
    });
};

/**
 * Restituisce il feed del profilo FIT
 */
export const getApiFitPlayerProfilesByIdFeed = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdFeedData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdFeedResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/feed',
        ...options
    });
};

/**
 * Restituisce i visitatori del profilo FIT
 */
export const getApiFitPlayerProfilesByIdVisitors = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdVisitorsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdVisitorsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/visitors',
        ...options
    });
};

/**
 * Get player followers list
 */
export const getApiFitPlayerProfilesFollowersListById = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesFollowersListByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesFollowersListByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/followers_list/{id}',
        ...options
    });
};

/**
 * Restituisce le info utente collegate al profilo FIT
 */
export const getApiFitPlayerProfilesByIdUserInfo = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdUserInfoData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdUserInfoResponses, unknown, ThrowOnError>({
        url: '/api/fit-player-profiles/{id}/user-info',
        ...options
    });
};

/**
 * Mostra il profilo FIT ridotto (per crawler)
 */
export const getApiFitPlayerProfilesByIdReduced = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesByIdReducedData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesByIdReducedResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/{id}/reduced',
        ...options
    });
};

/**
 * Restituisce i profili FIT più visitati
 */
export const getApiFitPlayerProfilesMostVisited = <ThrowOnError extends boolean = false>(options?: Options<GetApiFitPlayerProfilesMostVisitedData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiFitPlayerProfilesMostVisitedResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/most_visited',
        ...options
    });
};

/**
 * Controlla la validità di un fit_card_number
 */
export const postApiFitPlayerProfilesCheckFitCardNumber = <ThrowOnError extends boolean = false>(options: Options<PostApiFitPlayerProfilesCheckFitCardNumberData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiFitPlayerProfilesCheckFitCardNumberResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/check-fit-card-number',
        ...options
    });
};

/**
 * Restituisce l'ID dato un numero di tessera
 */
export const getApiFitPlayerProfilesCardToIdByCardNumber = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesCardToIdByCardNumberData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesCardToIdByCardNumberResponses, GetApiFitPlayerProfilesCardToIdByCardNumberErrors, ThrowOnError>({
        url: '/api/fit-player-profiles/card-to-id/{card_number}',
        ...options
    });
};

/**
 * Search players for merging
 */
export const getApiFitPlayerProfilesSearchForMerge = <ThrowOnError extends boolean = false>(options?: Options<GetApiFitPlayerProfilesSearchForMergeData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiFitPlayerProfilesSearchForMergeResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/search-for-merge',
        ...options
    });
};

/**
 * Effettua il merge tra due profili
 */
export const putApiFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerId = <ThrowOnError extends boolean = false>(options: Options<PutApiFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/merge/{source_player_id}/{destination_player_id}',
        ...options
    });
};

/**
 * Restituisce la home con post e magazine
 */
export const getApiHome = <ThrowOnError extends boolean = false>(options?: Options<GetApiHomeData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiHomeResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/home',
        ...options
    });
};

/**
 * Restituisce i numeri principali della piattaforma
 */
export const getApiHomeNumbers = <ThrowOnError extends boolean = false>(options?: Options<GetApiHomeNumbersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiHomeNumbersResponses, unknown, ThrowOnError>({
        url: '/api/home/numbers',
        ...options
    });
};

/**
 * Restituisce le notifiche non lette dell'utente
 */
export const getApiHomeNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetApiHomeNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiHomeNotificationsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/home/notifications',
        ...options
    });
};

/**
 * Restituisce i numeri per il backoffice
 */
export const getApiHomeBackofficeNumbers = <ThrowOnError extends boolean = false>(options?: Options<GetApiHomeBackofficeNumbersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiHomeBackofficeNumbersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/home/backoffice_numbers',
        ...options
    });
};

/**
 * Ricerca rapida globale
 */
export const postApiHomeInlineSearch = <ThrowOnError extends boolean = false>(options: Options<PostApiHomeInlineSearchData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiHomeInlineSearchResponses, unknown, ThrowOnError>({
        url: '/api/home/inline-search',
        ...options
    });
};

/**
 * Ricerca rapida giocatori
 */
export const postApiHomeInlineSearchPlayers = <ThrowOnError extends boolean = false>(options: Options<PostApiHomeInlineSearchPlayersData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiHomeInlineSearchPlayersResponses, unknown, ThrowOnError>({
        url: '/api/home/inline-search-players',
        ...options
    });
};

/**
 * Invia un invito tramite email
 */
export const postApiHomeInvitation = <ThrowOnError extends boolean = false>(options: Options<PostApiHomeInvitationData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiHomeInvitationResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/home/invitation',
        ...options
    });
};

/**
 * Restituisce il rate della piattaforma
 */
export const getApiHomeRate = <ThrowOnError extends boolean = false>(options?: Options<GetApiHomeRateData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiHomeRateResponses, unknown, ThrowOnError>({
        url: '/api/home/rate',
        ...options
    });
};

/**
 * Invia una notifica a tutti gli utenti
 */
export const postApiHomeSendAllNotifications = <ThrowOnError extends boolean = false>(options: Options<PostApiHomeSendAllNotificationsData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiHomeSendAllNotificationsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/home/send_all_notifications',
        ...options
    });
};

/**
 * Mette like a un post
 */
export const postApiPostsByIdLike = <ThrowOnError extends boolean = false>(options: Options<PostApiPostsByIdLikeData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiPostsByIdLikeResponses, PostApiPostsByIdLikeErrors, ThrowOnError>({
        responseTransformer: postApiPostsByIdLikeResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/posts/{id}/like',
        ...options
    });
};

/**
 * Rimuove il like da un post
 */
export const deleteApiPostsByIdUnlike = <ThrowOnError extends boolean = false>(options: Options<DeleteApiPostsByIdUnlikeData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiPostsByIdUnlikeResponses, DeleteApiPostsByIdUnlikeErrors, ThrowOnError>({
        responseTransformer: deleteApiPostsByIdUnlikeResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/posts/{id}/unlike',
        ...options
    });
};

/**
 * Lista dei match
 */
export const getApiMatches = <ThrowOnError extends boolean = false>(options?: Options<GetApiMatchesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiMatchesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/matches',
        ...options
    });
};

/**
 * Crea un nuovo match
 */
export const postApiMatches = <ThrowOnError extends boolean = false>(options?: Options<PostApiMatchesData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiMatchesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/matches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Elimina un match
 */
export const deleteApiMatchesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiMatchesByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiMatchesByIdResponses, DeleteApiMatchesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/matches/{id}',
        ...options
    });
};

/**
 * Mostra un match
 */
export const getApiMatchesById = <ThrowOnError extends boolean = false>(options: Options<GetApiMatchesByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiMatchesByIdResponses, GetApiMatchesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/matches/{id}',
        ...options
    });
};

/**
 * Aggiorna un match
 */
export const patchApiMatchesById = <ThrowOnError extends boolean = false>(options: Options<PatchApiMatchesByIdData, ThrowOnError>) => {
    return (options.client ?? client).patch<PatchApiMatchesByIdResponses, PatchApiMatchesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/matches/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Aggiorna un match
 */
export const putApiMatchesById = <ThrowOnError extends boolean = false>(options: Options<PutApiMatchesByIdData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiMatchesByIdResponses, PutApiMatchesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/matches/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Aggiorna solo il risultato di un match
 */
export const putApiMatchesByIdResult = <ThrowOnError extends boolean = false>(options: Options<PutApiMatchesByIdResultData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiMatchesByIdResultResponses, PutApiMatchesByIdResultErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/matches/{id}/result',
        ...options
    });
};

/**
 * Delete offer
 */
export const deleteApiOffersById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiOffersByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiOffersByIdResponses, DeleteApiOffersByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/offers/{id}',
        ...options
    });
};

/**
 * Get offer details
 */
export const getApiOffersById = <ThrowOnError extends boolean = false>(options: Options<GetApiOffersByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiOffersByIdResponses, GetApiOffersByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/offers/{id}',
        ...options
    });
};

/**
 * Update offer
 */
export const patchApiOffersById = <ThrowOnError extends boolean = false>(options: Options<PatchApiOffersByIdData, ThrowOnError>) => {
    return (options.client ?? client).patch<PatchApiOffersByIdResponses, PatchApiOffersByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/offers/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update offer
 */
export const putApiOffersById = <ThrowOnError extends boolean = false>(options: Options<PutApiOffersByIdData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiOffersByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/offers/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search offers
 */
export const postApiOffersSearch = <ThrowOnError extends boolean = false>(options?: Options<PostApiOffersSearchData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiOffersSearchResponses, unknown, ThrowOnError>({
        url: '/api/offers/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get private offers
 */
export const getApiOffersPrivates = <ThrowOnError extends boolean = false>(options?: Options<GetApiOffersPrivatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiOffersPrivatesResponses, GetApiOffersPrivatesErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/offers/privates',
        ...options
    });
};

/**
 * Get shop offers
 */
export const getApiOffersShops = <ThrowOnError extends boolean = false>(options: Options<GetApiOffersShopsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiOffersShopsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/offers/shops',
        ...options
    });
};

/**
 * Create offer
 */
export const postApiOffers = <ThrowOnError extends boolean = false>(options?: Options<PostApiOffersData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiOffersResponses, PostApiOffersErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/offers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Creates a new post
 */
export const postApiPosts = <ThrowOnError extends boolean = false>(options?: Options<PostApiPostsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiPostsResponses, PostApiPostsErrors, ThrowOnError>({
        responseTransformer: postApiPostsResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/posts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * user registration
 */
export const postApiUsersSignUp = <ThrowOnError extends boolean = false>(options?: Options<PostApiUsersSignUpData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiUsersSignUpResponses, unknown, ThrowOnError>({
        responseTransformer: postApiUsersSignUpResponseTransformer,
        url: '/api/users/sign-up',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * update user additional information
 */
export const postApiUsersSignUpAdditionalInfo = <ThrowOnError extends boolean = false>(options?: Options<PostApiUsersSignUpAdditionalInfoData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiUsersSignUpAdditionalInfoResponses, PostApiUsersSignUpAdditionalInfoErrors, ThrowOnError>({
        responseTransformer: postApiUsersSignUpAdditionalInfoResponseTransformer,
        url: '/api/users/sign-up/additional-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * complete user profile with professional profiles
 */
export const postApiUsersCompleteProfile = <ThrowOnError extends boolean = false>(options?: Options<PostApiUsersCompleteProfileData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiUsersCompleteProfileResponses, PostApiUsersCompleteProfileErrors, ThrowOnError>({
        url: '/api/users/complete-profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ricerca giocatori
 */
export const postApiSearchPlayers = <ThrowOnError extends boolean = false>(options?: Options<PostApiSearchPlayersData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSearchPlayersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/search/players',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ricerca club
 */
export const postApiSearchClubs = <ThrowOnError extends boolean = false>(options?: Options<PostApiSearchClubsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSearchClubsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/search/clubs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ricerca competizioni
 */
export const postApiSearchCompetitions = <ThrowOnError extends boolean = false>(options?: Options<PostApiSearchCompetitionsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSearchCompetitionsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/search/competitions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ricerca altri profili
 */
export const postApiSearchOtherProfiles = <ThrowOnError extends boolean = false>(options?: Options<PostApiSearchOtherProfilesData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSearchOtherProfilesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/search/other_profiles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Logs in a user with email and password
 */
export const postApiSessions = <ThrowOnError extends boolean = false>(options?: Options<PostApiSessionsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSessionsResponses, unknown, ThrowOnError>({
        responseTransformer: postApiSessionsResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/sessions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Receive order webhook from Shopify
 */
export const postApiShopifyOrder = <ThrowOnError extends boolean = false>(options: Options<PostApiShopifyOrderData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiShopifyOrderResponses, PostApiShopifyOrderErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/shopify/order',
        ...options
    });
};

/**
 * Get tournament details
 */
export const getApiTournamentsById = <ThrowOnError extends boolean = false>(options: Options<GetApiTournamentsByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiTournamentsByIdResponses, GetApiTournamentsByIdErrors, ThrowOnError>({
        url: '/api/tournaments/{id}',
        ...options
    });
};

/**
 * get user by id
 */
export const getApiUsersById = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/{id}',
        ...options
    });
};

/**
 * get user posts
 */
export const getApiUsersByIdPosts = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersByIdPostsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersByIdPostsResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersByIdPostsResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/{id}/posts',
        ...options
    });
};

/**
 * get user preview
 */
export const getApiUsersByIdPreview = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersByIdPreviewData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersByIdPreviewResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersByIdPreviewResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/{id}/preview',
        ...options
    });
};

/**
 * get user notifications
 */
export const getApiUsersNotifications = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersNotificationsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersNotificationsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/notifications',
        ...options
    });
};

/**
 * get user notifications dropdown
 */
export const getApiUsersNotificationsDropdown = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersNotificationsDropdownData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersNotificationsDropdownResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/notifications_dropdown',
        ...options
    });
};

/**
 * get user followers list
 */
export const getApiUsersFollowersListById = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersFollowersListByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersFollowersListByIdResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersFollowersListByIdResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/followers_list/{id}',
        ...options
    });
};

/**
 * get preferred surfaces
 */
export const getApiUsersPreferredSurfaces = <ThrowOnError extends boolean = false>(options?: Options<GetApiUsersPreferredSurfacesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiUsersPreferredSurfacesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/preferred_surfaces',
        ...options
    });
};

/**
 * get teacher qualifications
 */
export const getApiUsersTeacherQualifications = <ThrowOnError extends boolean = false>(options?: Options<GetApiUsersTeacherQualificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiUsersTeacherQualificationsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/teacher_qualifications',
        ...options
    });
};

/**
 * get trainer qualifications
 */
export const getApiUsersTrainerQualifications = <ThrowOnError extends boolean = false>(options?: Options<GetApiUsersTrainerQualificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiUsersTrainerQualificationsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/trainer_qualifications',
        ...options
    });
};

/**
 * get facebook info by token
 */
export const getApiUsersFacebookInfoByToken = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersFacebookInfoByTokenData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersFacebookInfoByTokenResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/facebook-info/{token}',
        ...options
    });
};

/**
 * confirm user account
 */
export const getApiUsersConfirmAccountByToken = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersConfirmAccountByTokenData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersConfirmAccountByTokenResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/confirm-account/{token}',
        ...options
    });
};

/**
 * send account confirmation email
 */
export const postApiUsersAccountConfirmationEmail = <ThrowOnError extends boolean = false>(options: Options<PostApiUsersAccountConfirmationEmailData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiUsersAccountConfirmationEmailResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/account-confirmation-email',
        ...options
    });
};

/**
 * get fit player id by token
 */
export const getApiUsersByTokenFitPlayerId = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersByTokenFitPlayerIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersByTokenFitPlayerIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/{token}/fit-player-id',
        ...options
    });
};

/**
 * get user feed
 */
export const getApiUsersFeed = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersFeedData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersFeedResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersFeedResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/feed',
        ...options
    });
};

/**
 * get user feed posts
 */
export const getApiUsersFeedPosts = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersFeedPostsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersFeedPostsResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersFeedPostsResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/feed-posts',
        ...options
    });
};

/**
 * get user feed matches
 */
export const getApiUsersFeedMatches = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersFeedMatchesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersFeedMatchesResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersFeedMatchesResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/feed-matches',
        ...options
    });
};

/**
 * get user feed offers
 */
export const getApiUsersFeedOffers = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersFeedOffersData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersFeedOffersResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersFeedOffersResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/feed-offers',
        ...options
    });
};

/**
 * get news feed
 */
export const getApiUsersFeedNews = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersFeedNewsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersFeedNewsResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersFeedNewsResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/feed-news',
        ...options
    });
};

/**
 * get user market offers
 */
export const postApiUsersMarket = <ThrowOnError extends boolean = false>(options: Options<PostApiUsersMarketData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiUsersMarketResponses, unknown, ThrowOnError>({
        responseTransformer: postApiUsersMarketResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/market',
        ...options
    });
};

/**
 * get user matches
 */
export const getApiUsersUserMatches = <ThrowOnError extends boolean = false>(options: Options<GetApiUsersUserMatchesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUsersUserMatchesResponses, unknown, ThrowOnError>({
        responseTransformer: getApiUsersUserMatchesResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/user-matches',
        ...options
    });
};

/**
 * accept market conditions
 */
export const putApiUsersMarketConditionAccepted = <ThrowOnError extends boolean = false>(options: Options<PutApiUsersMarketConditionAcceptedData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiUsersMarketConditionAcceptedResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/market-condition-accepted',
        ...options
    });
};

/**
 * check fit club id
 */
export const postApiUsersCheckFitClubId = <ThrowOnError extends boolean = false>(options: Options<PostApiUsersCheckFitClubIdData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiUsersCheckFitClubIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/check-fit-club-id',
        ...options
    });
};

/**
 * Lista i bonus del profilo giocatore corrente
 */
export const getApiBonuses = <ThrowOnError extends boolean = false>(options?: Options<GetApiBonusesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiBonusesResponses, GetApiBonusesErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/bonuses',
        ...options
    });
};

/**
 * Crea un nuovo bonus per il profilo giocatore corrente
 */
export const postApiBonuses = <ThrowOnError extends boolean = false>(options?: Options<PostApiBonusesData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiBonusesResponses, PostApiBonusesErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/bonuses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Elimina un bonus dal profilo giocatore corrente
 */
export const deleteApiBonusesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiBonusesByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiBonusesByIdResponses, DeleteApiBonusesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/bonuses/{id}',
        ...options
    });
};

/**
 * Crea un nuovo commento su un post
 */
export const postApiPostsByPostIdComments = <ThrowOnError extends boolean = false>(options: Options<PostApiPostsByPostIdCommentsData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiPostsByPostIdCommentsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/posts/{post_id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Elimina un commento
 */
export const deleteApiPostsByPostIdCommentsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiPostsByPostIdCommentsByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiPostsByPostIdCommentsByIdResponses, DeleteApiPostsByPostIdCommentsByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/posts/{post_id}/comments/{id}',
        ...options
    });
};

/**
 * Aggiorna un commento
 */
export const patchApiPostsByPostIdCommentsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiPostsByPostIdCommentsByIdData, ThrowOnError>) => {
    return (options.client ?? client).patch<PatchApiPostsByPostIdCommentsByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/posts/{post_id}/comments/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Invia una richiesta di contatto
 */
export const postApiContacts = <ThrowOnError extends boolean = false>(options?: Options<PostApiContactsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiContactsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Restituisce tutti i custom banners
 */
export const getApiCustomBannersAll = <ThrowOnError extends boolean = false>(options?: Options<GetApiCustomBannersAllData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiCustomBannersAllResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/custom_banners/all',
        ...options
    });
};

/**
 * Restituisce i custom banners paginati
 */
export const getApiCustomBanners = <ThrowOnError extends boolean = false>(options?: Options<GetApiCustomBannersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiCustomBannersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/custom_banners',
        ...options
    });
};

/**
 * Crea un nuovo custom banner
 */
export const postApiCustomBanners = <ThrowOnError extends boolean = false>(options?: Options<PostApiCustomBannersData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiCustomBannersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/custom_banners',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Elimina un custom banner
 */
export const deleteApiCustomBannersById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiCustomBannersByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiCustomBannersByIdResponses, DeleteApiCustomBannersByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/custom_banners/{id}',
        ...options
    });
};

/**
 * Mostra un custom banner
 */
export const getApiCustomBannersById = <ThrowOnError extends boolean = false>(options: Options<GetApiCustomBannersByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiCustomBannersByIdResponses, GetApiCustomBannersByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/custom_banners/{id}',
        ...options
    });
};

/**
 * Aggiorna un custom banner
 */
export const patchApiCustomBannersById = <ThrowOnError extends boolean = false>(options: Options<PatchApiCustomBannersByIdData, ThrowOnError>) => {
    return (options.client ?? client).patch<PatchApiCustomBannersByIdResponses, PatchApiCustomBannersByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/custom_banners/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Aggiorna un custom banner
 */
export const putApiCustomBannersById = <ThrowOnError extends boolean = false>(options: Options<PutApiCustomBannersByIdData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiCustomBannersByIdResponses, PutApiCustomBannersByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/custom_banners/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Crea un endorsement
 */
export const postApiEndorsements = <ThrowOnError extends boolean = false>(options?: Options<PostApiEndorsementsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiEndorsementsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/endorsements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Elimina un endorsement
 */
export const deleteApiEndorsementsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiEndorsementsByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiEndorsementsByIdResponses, DeleteApiEndorsementsByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/endorsements/{id}',
        ...options
    });
};

/**
 * Restituisce le news del feed
 */
export const getApiFeedNews = <ThrowOnError extends boolean = false>(options?: Options<GetApiFeedNewsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiFeedNewsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/feed_news',
        ...options
    });
};

/**
 * Restituisce la lista delle richieste di profilo FIT
 */
export const getApiFitPlayerProfileRequests = <ThrowOnError extends boolean = false>(options?: Options<GetApiFitPlayerProfileRequestsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiFitPlayerProfileRequestsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profile-requests',
        ...options
    });
};

/**
 * Ricerca profili per merge
 */
export const getApiFitPlayerProfilesSearchForMergeByQ = <ThrowOnError extends boolean = false>(options: Options<GetApiFitPlayerProfilesSearchForMergeByQData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiFitPlayerProfilesSearchForMergeByQResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/fit-player-profiles/search-for-merge/{q}',
        ...options
    });
};

/**
 * Crea un follow
 */
export const postApiFollows = <ThrowOnError extends boolean = false>(options: Options<PostApiFollowsData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiFollowsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/follows',
        ...options
    });
};

/**
 * Rimuove un follow
 */
export const postApiRemoveFollow = <ThrowOnError extends boolean = false>(options: Options<PostApiRemoveFollowData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiRemoveFollowResponses, PostApiRemoveFollowErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/remove-follow',
        ...options
    });
};

/**
 * Restituisce la conversazione tra due profili
 */
export const getApiMessagesConversation = <ThrowOnError extends boolean = false>(options: Options<GetApiMessagesConversationData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiMessagesConversationResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/messages/conversation',
        ...options
    });
};

/**
 * Crea un nuovo messaggio
 */
export const postApiMessages = <ThrowOnError extends boolean = false>(options?: Options<PostApiMessagesData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiMessagesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/messages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Blocca un messaggio
 */
export const putApiMessagesByIdBlock = <ThrowOnError extends boolean = false>(options: Options<PutApiMessagesByIdBlockData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiMessagesByIdBlockResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/messages/{id}/block',
        ...options
    });
};

/**
 * Restituisce i profili con cui l'utente ha scambiato messaggi
 */
export const getApiUsersMessagesCounterparts = <ThrowOnError extends boolean = false>(options?: Options<GetApiUsersMessagesCounterpartsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiUsersMessagesCounterpartsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/users/messages-counterparts',
        ...options
    });
};

/**
 * Restituisce il banner posizionato per slot
 */
export const getApiPositionedBannersBySlot = <ThrowOnError extends boolean = false>(options: Options<GetApiPositionedBannersBySlotData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiPositionedBannersBySlotResponses, GetApiPositionedBannersBySlotErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/positioned-banners/{slot}',
        ...options
    });
};

/**
 * Restituisce i banner posizionati paginati
 */
export const getApiPositionedBanners = <ThrowOnError extends boolean = false>(options?: Options<GetApiPositionedBannersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiPositionedBannersResponses, unknown, ThrowOnError>({
        responseTransformer: getApiPositionedBannersResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/positioned-banners',
        ...options
    });
};

/**
 * Crea un nuovo banner posizionato
 */
export const postApiPositionedBanners = <ThrowOnError extends boolean = false>(options?: Options<PostApiPositionedBannersData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiPositionedBannersResponses, unknown, ThrowOnError>({
        responseTransformer: postApiPositionedBannersResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/positioned-banners',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Restituisce un banner posizionato specifico
 */
export const getApiPositionedBannersByIdById = <ThrowOnError extends boolean = false>(options: Options<GetApiPositionedBannersByIdByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiPositionedBannersByIdByIdResponses, GetApiPositionedBannersByIdByIdErrors, ThrowOnError>({
        responseTransformer: getApiPositionedBannersByIdByIdResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/positioned-banners/by-id/{id}',
        ...options
    });
};

/**
 * Elimina un banner posizionato
 */
export const deleteApiPositionedBannersById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiPositionedBannersByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiPositionedBannersByIdResponses, unknown, ThrowOnError>({
        responseTransformer: deleteApiPositionedBannersByIdResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/positioned-banners/{id}',
        ...options
    });
};

/**
 * Aggiorna un banner posizionato
 */
export const putApiPositionedBannersById = <ThrowOnError extends boolean = false>(options: Options<PutApiPositionedBannersByIdData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiPositionedBannersByIdResponses, unknown, ThrowOnError>({
        responseTransformer: putApiPositionedBannersByIdResponseTransformer,
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/positioned-banners/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lista i premium tokens
 */
export const getApiPremiumTokens = <ThrowOnError extends boolean = false>(options?: Options<GetApiPremiumTokensData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiPremiumTokensResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/premium_tokens',
        ...options
    });
};

/**
 * Crea un nuovo premium token
 */
export const postApiPremiumTokens = <ThrowOnError extends boolean = false>(options?: Options<PostApiPremiumTokensData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiPremiumTokensResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/premium_tokens',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Elimina un premium token
 */
export const deleteApiPremiumTokensById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiPremiumTokensByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiPremiumTokensByIdResponses, DeleteApiPremiumTokensByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/premium_tokens/{id}',
        ...options
    });
};

/**
 * Mostra un premium token specifico
 */
export const getApiPremiumTokensById = <ThrowOnError extends boolean = false>(options: Options<GetApiPremiumTokensByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiPremiumTokensByIdResponses, GetApiPremiumTokensByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/premium_tokens/{id}',
        ...options
    });
};

/**
 * Aggiorna un premium token
 */
export const putApiPremiumTokensById = <ThrowOnError extends boolean = false>(options: Options<PutApiPremiumTokensByIdData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiPremiumTokensByIdResponses, PutApiPremiumTokensByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/premium_tokens/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Invia email di membership per un premium token
 */
export const postApiPremiumTokensMembershipEmail = <ThrowOnError extends boolean = false>(options: Options<PostApiPremiumTokensMembershipEmailData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiPremiumTokensMembershipEmailResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/premium_tokens/membership_email',
        ...options
    });
};

/**
 * Ottiene la cardinalità del ranking per l'anno corrente
 */
export const getApiCardinality = <ThrowOnError extends boolean = false>(options?: Options<GetApiCardinalityData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiCardinalityResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/cardinality',
        ...options
    });
};

/**
 * Salva un nuovo ranking per il giocatore corrente
 */
export const postApiCardinalitySave = <ThrowOnError extends boolean = false>(options: Options<PostApiCardinalitySaveData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiCardinalitySaveResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/cardinality/save',
        ...options
    });
};

/**
 * Richiede il reset della password
 */
export const putApiResetPasswordRequest = <ThrowOnError extends boolean = false>(options: Options<PutApiResetPasswordRequestData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiResetPasswordRequestResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/reset-password/request',
        ...options
    });
};

/**
 * Resetta la password usando il token
 */
export const putApiResetPassword = <ThrowOnError extends boolean = false>(options: Options<PutApiResetPasswordData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiResetPasswordResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/reset-password',
        ...options
    });
};

/**
 * Elimina la ricerca di competizioni salvata
 */
export const deleteApiSavedCompetitionSearch = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiSavedCompetitionSearchData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteApiSavedCompetitionSearchResponses, DeleteApiSavedCompetitionSearchErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/saved-competition-search',
        ...options
    });
};

/**
 * Ottiene la ricerca di competizioni salvata dell'utente
 */
export const getApiSavedCompetitionSearch = <ThrowOnError extends boolean = false>(options?: Options<GetApiSavedCompetitionSearchData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiSavedCompetitionSearchResponses, GetApiSavedCompetitionSearchErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/saved-competition-search',
        ...options
    });
};

/**
 * Crea o aggiorna la ricerca di competizioni salvata
 */
export const postApiSavedCompetitionSearch = <ThrowOnError extends boolean = false>(options?: Options<PostApiSavedCompetitionSearchData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiSavedCompetitionSearchResponses, PostApiSavedCompetitionSearchErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/saved-competition-search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Lista gli update tasks (richiede autorizzazione admin)
 */
export const getApiUpdateTasks = <ThrowOnError extends boolean = false>(options?: Options<GetApiUpdateTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiUpdateTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks',
        ...options
    });
};

/**
 * Crea un nuovo update task
 */
export const postApiUpdateTasks = <ThrowOnError extends boolean = false>(options?: Options<PostApiUpdateTasksData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiUpdateTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Esegue un update task specifico
 */
export const putApiUpdateTasksByIdRun = <ThrowOnError extends boolean = false>(options: Options<PutApiUpdateTasksByIdRunData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiUpdateTasksByIdRunResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks/{id}/run',
        ...options
    });
};

/**
 * Imposta un update task come pending
 */
export const putApiUpdateTasksByIdSetPending = <ThrowOnError extends boolean = false>(options: Options<PutApiUpdateTasksByIdSetPendingData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiUpdateTasksByIdSetPendingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks/{id}/set_pending',
        ...options
    });
};

/**
 * Aggiorna la cache Redis
 */
export const postApiUpdateTasksCacheRefresh = <ThrowOnError extends boolean = false>(options?: Options<PostApiUpdateTasksCacheRefreshData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiUpdateTasksCacheRefreshResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks/cache_refresh',
        ...options
    });
};

/**
 * Riavvia i server EC2
 */
export const postApiUpdateTasksRestartServers = <ThrowOnError extends boolean = false>(options?: Options<PostApiUpdateTasksRestartServersData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiUpdateTasksRestartServersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks/restart_servers',
        ...options
    });
};

/**
 * Esegue il ripristino di un dump del database
 */
export const postApiUpdateTasksRunRestoreDump = <ThrowOnError extends boolean = false>(options: Options<PostApiUpdateTasksRunRestoreDumpData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiUpdateTasksRunRestoreDumpResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks/run-restore-dump',
        ...options
    });
};

/**
 * Esegue un job asincrono specifico (richiede autorizzazione admin)
 */
export const postApiUpdateTasksRunAsyncJob = <ThrowOnError extends boolean = false>(options: Options<PostApiUpdateTasksRunAsyncJobData, ThrowOnError>) => {
    return (options.client ?? client).post<PostApiUpdateTasksRunAsyncJobResponses, PostApiUpdateTasksRunAsyncJobErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/update-tasks/run_async_job',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lista i match utente
 */
export const getApiUserMatches = <ThrowOnError extends boolean = false>(options?: Options<GetApiUserMatchesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiUserMatchesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches',
        ...options
    });
};

/**
 * Crea un nuovo match utente
 */
export const postApiUserMatches = <ThrowOnError extends boolean = false>(options?: Options<PostApiUserMatchesData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiUserMatchesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Elimina un match utente
 */
export const deleteApiUserMatchesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiUserMatchesByIdData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteApiUserMatchesByIdResponses, DeleteApiUserMatchesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches/{id}',
        ...options
    });
};

/**
 * Mostra un match utente specifico
 */
export const getApiUserMatchesById = <ThrowOnError extends boolean = false>(options: Options<GetApiUserMatchesByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiUserMatchesByIdResponses, GetApiUserMatchesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches/{id}',
        ...options
    });
};

/**
 * Aggiorna un match utente
 */
export const putApiUserMatchesById = <ThrowOnError extends boolean = false>(options: Options<PutApiUserMatchesByIdData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiUserMatchesByIdResponses, PutApiUserMatchesByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Conferma un match utente
 */
export const putApiUserMatchesByIdConfirm = <ThrowOnError extends boolean = false>(options: Options<PutApiUserMatchesByIdConfirmData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiUserMatchesByIdConfirmResponses, PutApiUserMatchesByIdConfirmErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches/{id}/confirm',
        ...options
    });
};

/**
 * Rifiuta un match utente
 */
export const putApiUserMatchesByIdReject = <ThrowOnError extends boolean = false>(options: Options<PutApiUserMatchesByIdRejectData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiUserMatchesByIdRejectResponses, PutApiUserMatchesByIdRejectErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches/{id}/reject',
        ...options
    });
};

/**
 * Aggiorna il risultato di un match utente
 */
export const putApiUserMatchesByIdResult = <ThrowOnError extends boolean = false>(options: Options<PutApiUserMatchesByIdResultData, ThrowOnError>) => {
    return (options.client ?? client).put<PutApiUserMatchesByIdResultResponses, PutApiUserMatchesByIdResultErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/user-matches/{id}/result',
        ...options
    });
};
